import { SellerChangeRequestStatus } from '@/types';

export interface ChangeRequestFilterValue {
    units: number[];
    groups: number[];
    statuses: SellerChangeRequestStatus[];
    participants: number[];
    searchText: string;
    includeArchived: boolean;
}

export function getInitialChangeRequestFilterValue(): ChangeRequestFilterValue {
    return {
        units: [],
        groups: [],
        statuses: [],
        participants: [],
        searchText: '',
        includeArchived: false,
    };
}

export { default } from './ChangeRequestFilter';


